export default {
  methods: {
    addGlobalWarn (code, severity, message) {
      this.$store.commit('addGlobalWarning', { code, severity, message })
    },
    removeGlobalWarn (code) {
      this.$store.commit('removeGlobalWarning', code)
    }
  }
}
